import { gql, useMutation } from '@apollo/client';
import { GET_DPO_TASKS, GetDpoTasksResult } from './useDpoTasksQuery';

const UPLOAD_DPO_TASK_FILE = gql`
  mutation UploadDpoTaskFile($file: Upload!, $size: Int!, $companyId: String!, $taskId: String!) {
    uploadDpoTaskFile(file: $file, size: $size, companyId: $companyId, taskId: $taskId)
  }
`;

export interface UploadDpoTaskFileResult {
  uploadDpoTaskFile: boolean;
}

export interface UploadDpoTaskFileInput {
  file: File;
  size: number;
  companyId: string;
  taskId: string;
}

export function useDpoTaskUploadFileMutation(companyId: string) {
  return useMutation<UploadDpoTaskFileResult, UploadDpoTaskFileInput>(UPLOAD_DPO_TASK_FILE, {
    context: {
      headers: {
        'apollo-require-preflight': true,
      },
    },
    update(cache, { data }, { variables }) {
      if (!data?.uploadDpoTaskFile || !variables) return;

      // Read current tasks from cache
      const existingData = cache.readQuery<GetDpoTasksResult>({
        query: GET_DPO_TASKS,
        variables: { companyId },
      });

      if (existingData?.getDpoTasks) {
        // Update the hasFile field for the specific task
        const updatedTasks = existingData.getDpoTasks.map((task) =>
          task.id === variables.taskId ? { ...task, hasFile: true } : task
        );

        // Write back to cache
        cache.writeQuery<GetDpoTasksResult>({
          query: GET_DPO_TASKS,
          variables: { companyId },
          data: { getDpoTasks: updatedTasks },
        });
      }
    },
  });
}
